export const eventBus = new Vue();
import Vue from 'vue';
import VueRouter from 'vue-router';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import Notifications from 'vue-notification';
import 'vue-loading-overlay/dist/vue-loading.css';

import App from './App.vue';
import router from './routing';
import store from './store';
import filters from '@/shared/filters';
import directives from '@/shared/directives';
import validatesExtend from '@/shared/validates-extension';
import * as firebase from 'firebase';
// import './registerServiceWorker';


import '@/styles/app.style.scss';

try {
  const firebaseConfig = {
    apiKey: 'AIzaSyAN2aQz5h9C_dGKNXkwYXx2xKmt4ON5FCM',
    authDomain: 'oee-app-cc5a1.firebaseapp.com',
    databaseURL: 'https://oee-app-cc5a1.firebaseio.com',
    projectId: 'oee-app-cc5a1',
    storageBucket: 'oee-app-cc5a1.appspot.com',
    messagingSenderId: '579480956217',
    appId: '1:579480956217:web:0e10030639ec0ab80ccce8',
    measurementId: 'G-54ZGV0VRV2'
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  const messaging = firebase.messaging();
  
  messaging.usePublicVapidKey('BJEzW26kiMFmeCbWlUoX6-OdGniKwskUFeFyRcLXeZe8O452EAEABKcrZ-SdYd2xt6CNG7rVzxEqf1WZdYvL6R4'); // 1. Generate a new key pair
  // Request Permission of Notifications
  messaging.requestPermission().then(() => {
    // console.log('Notification permission granted.');
    // Get Token
    messaging.getToken().then((token) => {
      window.localStorage.setItem('FCM_Token', JSON.stringify(token));
    })
  }).catch();
  messaging.onMessage((payload) => {
    // console.log('onMessage: ', payload);
  }); 
} catch (error) {
  // expected output: ReferenceError: nonExistentFunction is not defined
  // Note - error messages will vary depending on browser
}

Vue.config.productionTip = false;

// Validate
for (const rule in rules) {
  extend(rule, {
    ...rules[rule],
  });
}

for (const rule in validatesExtend) {
  extend(rule, {
    ...validatesExtend[rule],
  });
}

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// End Validate

// Filter
for (const filter in filters) {
  Vue.filter(filter, filters[filter]);
}
// End Filter

// Init Directive
for (const directive in directives) {
  Vue.directive(directive, directives[directive]);
}
// End Directive


// Notify
Vue.use(Notifications);
// End Notify


Vue.use(VueRouter);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
